import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  Input,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector     : 'nz-step',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <div class="ant-steps-tail" #stepsTail *ngIf="_last !== true">
      <i></i>
    </div>
    <div class="ant-steps-step">
      <div class="ant-steps-head" #stepsHead>
        <div class="ant-steps-head-inner">
          <ng-template [ngIf]="!_processDot">
            <span class="ant-steps-icon anticon anticon-check" *ngIf="_status === 'finish' && !nzIcon"></span>
            <span class="ant-steps-icon anticon anticon-cross" *ngIf="_status === 'error'"></span>
            <span class="ant-steps-icon" *ngIf="(_status === 'process' || _status === 'wait') && !nzIcon">{{ index + 1 }}</span>
            <span class="ant-steps-icon" *ngIf="nzIcon">
            <ng-template [ngTemplateOutlet]="nzIcon"></ng-template>
          </span>
          </ng-template>
          <ng-template [ngIf]="_processDot">
            <span class="ant-steps-icon">
              <span class="ant-steps-icon-dot"></span>
            </span>
          </ng-template>
        </div>
      </div>
      <div class="ant-steps-main" #stepsMain>
        <div class="ant-steps-title" [innerHTML]="nzTitle"></div>
        <div class="ant-steps-description">
          <ng-container *ngIf="_description; else _descriptionTpl">{{ _description }}</ng-container>
        </div>
      </div>
    </div>
  `,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-steps {
  font-size: 0;
  line-height: 1.5;
}
.ant-steps .ant-steps-item {
  position: relative;
  display: inline-block;
  vertical-align: top;
}
.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-head-inner {
  border-color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
}
.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-head-inner > .ant-steps-icon {
  color: rgba(0, 0, 0, 0.25);
}
.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {
  background: rgba(0, 0, 0, 0.25);
}
.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-title {
  color: rgba(0, 0, 0, 0.43);
}
.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-description {
  color: rgba(0, 0, 0, 0.43);
}
.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-tail > i {
  background-color: #e9e9e9;
}
.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-head-inner {
  border-color: #108ee9;
  background-color: #108ee9;
}
.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-head-inner > .ant-steps-icon {
  color: #fff;
}
.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {
  background: #108ee9;
}
.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-title {
  color: rgba(0, 0, 0, 0.65);
}
.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-description {
  color: rgba(0, 0, 0, 0.65);
}
.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-tail > i {
  background-color: #e9e9e9;
}
.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-head-inner {
  border-color: #108ee9;
  background-color: #fff;
}
.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-head-inner > .ant-steps-icon {
  color: #108ee9;
}
.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {
  background: #108ee9;
}
.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-tail > i:after {
  width: 100%;
  background: #108ee9;
  transition: all .6s;
  opacity: 1;
  box-shadow: 0 0 0 0 #108ee9;
  animation: tailEffect .4s;
}
.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-title {
  color: rgba(0, 0, 0, 0.43);
}
.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-description {
  color: rgba(0, 0, 0, 0.43);
}
.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-head-inner {
  border-color: #f04134;
  background-color: #fff;
}
.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-head-inner > .ant-steps-icon {
  color: #f04134;
}
.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {
  background: #f04134;
}
.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-title {
  color: #f04134;
}
.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-description {
  color: #f04134;
}
.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-tail > i {
  background-color: #e9e9e9;
}
.ant-steps .ant-steps-item.ant-steps-next-error .ant-steps-tail > i,
.ant-steps .ant-steps-item.ant-steps-next-error .ant-steps-tail > i:after {
  background-color: #f04134;
}
.ant-steps .ant-steps-item.ant-steps-custom .ant-steps-head-inner {
  background: none;
  border: 0;
  width: auto;
  height: auto;
}
.ant-steps .ant-steps-item.ant-steps-custom .ant-steps-head-inner > .ant-steps-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
}
.ant-steps .ant-steps-item.ant-steps-custom.ant-steps-status-process .ant-steps-head-inner > .ant-steps-icon {
  color: #108ee9;
}
.ant-steps .ant-steps-head,
.ant-steps .ant-steps-main {
  position: relative;
  display: inline-block;
  vertical-align: top;
}
.ant-steps .ant-steps-head {
  background: #fff;
}
.ant-steps .ant-steps-head-inner {
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.25);
  width: 26px;
  height: 26px;
  line-height: 23px;
  text-align: center;
  border-radius: 26px;
  font-size: 14px;
  margin-right: 8px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.ant-steps .ant-steps-head-inner > .ant-steps-icon {
  line-height: 1;
  color: #108ee9;
  position: relative;
}
.ant-steps .ant-steps-head-inner > .ant-steps-icon.anticon {
  font-size: 12px;
}
.ant-steps .ant-steps-head-inner > .ant-steps-icon.anticon-cross,
.ant-steps .ant-steps-head-inner > .ant-steps-icon.anticon-check {
  font-weight: bold;
}
.ant-steps .ant-steps-title {
  font-size: 14px;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: bold;
  background-color: #fff;
  display: inline-block;
  padding-right: 10px;
}
.ant-steps .ant-steps-title > a:first-child:last-child {
  color: rgba(0, 0, 0, 0.65);
}
.ant-steps .ant-steps-item:last-child .ant-steps-title {
  padding-right: 0;
  width: 100%;
}
.ant-steps .ant-steps-item:last-child .ant-steps-tail {
  display: none;
}
.ant-steps .ant-steps-description {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.43);
}
.ant-steps .ant-steps-tail {
  position: absolute;
  left: 0;
  width: 100%;
  top: 13px;
  padding: 0 10px;
}
.ant-steps .ant-steps-tail > i {
  display: inline-block;
  vertical-align: top;
  background: #e9e9e9;
  height: 1px;
  border-radius: 1px;
  width: 100%;
  position: relative;
}
.ant-steps .ant-steps-tail > i:after {
  position: absolute;
  content: '';
  top: 0;
  width: 0;
  background: #e9e9e9;
  height: 100%;
  opacity: 0;
}
.ant-steps.ant-steps-small .ant-steps-head-inner {
  border: 1px solid rgba(0, 0, 0, 0.25);
  width: 18px;
  height: 18px;
  line-height: 15px;
  text-align: center;
  border-radius: 18px;
  font-size: 12px;
  margin-right: 10px;
}
.ant-steps.ant-steps-small .ant-steps-head-inner > .ant-steps-icon.anticon {
  display: inline-block;
  font-size: 12px;
  font-size: 9px \9;
  transform: scale(0.75) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  top: 0;
}
:root .ant-steps.ant-steps-small .ant-steps-head-inner > .ant-steps-icon.anticon {
  filter: none;
}
:root .ant-steps.ant-steps-small .ant-steps-head-inner > .ant-steps-icon.anticon {
  font-size: 12px;
}
.ant-steps.ant-steps-small .ant-steps-main {
  margin-top: 0;
}
.ant-steps.ant-steps-small .ant-steps-title {
  font-size: 12px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: bold;
}
.ant-steps.ant-steps-small .ant-steps-description {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.43);
}
.ant-steps.ant-steps-small .ant-steps-tail {
  top: 8px;
  padding: 0 8px;
}
.ant-steps.ant-steps-small .ant-steps-tail > i {
  height: 1px;
  border-radius: 1px;
  width: 100%;
}
.ant-steps.ant-steps-small .ant-steps-custom .ant-steps-head-inner > .ant-steps-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ant-steps-vertical > .ant-steps-item {
  display: block;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-tail {
  position: absolute;
  left: 13px;
  top: 0;
  height: 100%;
  width: 1px;
  padding: 30px 0 4px;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-tail > i {
  height: 100%;
  width: 1px;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-tail > i:after {
  height: 0;
  width: 100%;
}
.ant-steps-vertical .ant-steps-status-finish .ant-steps-tail > i:after {
  height: 100%;
}
.ant-steps-vertical .ant-steps-head {
  float: left;
}
.ant-steps-vertical .ant-steps-head-inner {
  margin-right: 16px;
}
.ant-steps-vertical .ant-steps-main {
  min-height: 47px;
  overflow: hidden;
  display: block;
}
.ant-steps-vertical .ant-steps-main .ant-steps-title {
  line-height: 26px;
}
.ant-steps-vertical .ant-steps-main .ant-steps-description {
  padding-bottom: 12px;
}
.ant-steps-vertical.ant-steps-small .ant-steps-tail {
  position: absolute;
  left: 9px;
  top: 0;
  padding: 22px 0 4px;
}
.ant-steps-vertical.ant-steps-small .ant-steps-tail > i {
  height: 100%;
}
.ant-steps-vertical.ant-steps-small .ant-steps-title {
  line-height: 18px;
}
.ant-steps-horizontal.ant-steps-hidden {
  visibility: hidden;
}
.ant-steps-horizontal .ant-steps-description {
  max-width: 120px;
}
.ant-steps-horizontal .ant-steps-item:not(:first-child) .ant-steps-head {
  padding-left: 10px;
  margin-left: -10px;
}
.ant-steps-dot .ant-steps-item .ant-steps-step {
  display: inline-block;
  text-align: center;
  width: 120px;
}
.ant-steps-dot .ant-steps-item:not(:first-child) .ant-steps-head {
  margin-left: 0;
  padding-left: 0;
}
.ant-steps-dot .ant-steps-tail {
  margin: 0 0 0 60px;
  padding: 0;
  width: 100%;
  top: 1px;
}
.ant-steps-dot .ant-steps-tail > i {
  height: 3px;
}
.ant-steps-dot .ant-steps-head {
  display: inline-block;
  padding-right: 0;
}
.ant-steps-dot .ant-steps-head-inner {
  margin: 0 auto;
  width: 5px;
  height: 5px;
  line-height: 5px;
  border: 0;
}
.ant-steps-dot .ant-steps-head-inner .ant-steps-icon-dot {
  float: left;
  width: 100%;
  height: 100%;
  border-radius: 2.5px;
  position: relative;
}
.ant-steps-dot .ant-steps-head-inner .ant-steps-icon-dot:after {
  content: '';
  background: rgba(255, 255, 255, 0.001);
  width: 40px;
  height: 24px;
  position: absolute;
  top: -8px;
  left: -16px;
}
.ant-steps-dot .ant-steps-head-inner .ant-steps-icon-dot:hover {
  transform: scale(1.3);
}
.ant-steps-dot .ant-steps-main {
  display: block;
  margin-top: 10px;
}
.ant-steps-dot .ant-steps-main .ant-steps-title {
  padding-right: 0;
  background-color: transparent;
}
.ant-steps-dot .ant-steps-status-process .ant-steps-head {
  top: -1px;
}
.ant-steps-dot .ant-steps-status-process .ant-steps-head-inner {
  width: 7px;
  height: 7px;
  line-height: 7px;
}
.ant-steps-dot .ant-steps-status-process .ant-steps-head-inner .ant-steps-icon-dot {
  border-radius: 3.5px;
}
.ant-steps-dot.ant-steps-vertical .ant-steps-tail {
  left: 2px;
  height: 100%;
  padding: 0;
  top: 15px;
}
.ant-steps-dot.ant-steps-vertical .ant-steps-tail > i {
  height: 100%;
  width: 3px;
}
.ant-steps-dot.ant-steps-vertical .ant-steps-head {
  top: 12px;
  left: 1px;
}
.ant-steps-dot.ant-steps-vertical .ant-steps-status-process .ant-steps-head {
  left: 0;
}
@keyframes tailEffect {
  to {
    box-shadow: 0 0 3px 3px transparent;
  }
}
`,
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-steps-horizontal nz-step:not(:first-child) .ant-steps-head {
  padding-left: 10px;
  margin-left: -10px;
}
nz-step {
  display: block;
}
.ant-steps-dot.ant-steps-vertical .ant-steps-tail {
  margin-left: 0;
}
.ant-steps-dot.ant-steps-vertical .ant-steps-step {
  text-align: left;
  width: auto;
}
.ant-steps-dot.ant-steps-vertical .ant-steps-head-inner {
  margin-right: 16px;
}
.ant-steps-dot.ant-steps-vertical .ant-steps-main {
  margin-top: 0;
}
`
  ]
})
export class NzStepComponent implements AfterViewInit {
  _status = 'wait';
  _ifCustomStatus = false;
  _totalCount = 1;
  _currentIndex = 0;
  _el;
  _last = false;
  _first = false;
  _processDot = false;
  _direction = 'horizontal';
  _outStatus = 'process';
  index = 0;
  stepStatusClass;
  @ContentChild('nzIcon') nzIcon: TemplateRef<void>;
  @ViewChild('stepsTail') _stepsTail: ElementRef;
  @ViewChild('stepsHead') _stepsHead: ElementRef;
  @ViewChild('stepsMain') _stepsMain: ElementRef;

  @Input()
  set nzStatus(status: string) {
    this._status = status;
    this._ifCustomStatus = true;
  }

  get nzStatus(): string {
    return this._status;
  }

  @Input() nzTitle: string;

  _description = '';
  _descriptionTpl: TemplateRef<void>;

  @Input()
  set nzDescription(value: string | TemplateRef<void>) {
    if (value instanceof TemplateRef) {
      this._descriptionTpl = value;
    } else {
      this._description = value as string;
    }
  }

  get _current(): number {
    return this._currentIndex;
  }

  set _current(current: number) {
    this._currentIndex = current;
    if (!this._ifCustomStatus) {
      if (current > this.index) {
        this._status = 'finish';
      } else if (current === this.index) {
        if (this._outStatus) {
          this._status = 'error';
        } else {
          this._status = 'process';
        }
      } else {
        this._status = 'wait';
      }
    }
    this.initClassMap();
  }

  initClassMap(): void {
    this.stepStatusClass = {
      ['ant-steps-item']          : true,
      [`ant-steps-status-wait`]   : this._status === 'wait',
      [`ant-steps-status-process`]: this._status === 'process',
      [`ant-steps-status-finish`] : this._status === 'finish',
      [`ant-steps-status-error`]  : this._status === 'error',
      ['ant-steps-item-last']     : this._last,
      ['ant-steps-custom']        : !!this.nzIcon,
      ['ant-steps-next-error']    : (this._outStatus === 'error' && this._current === this.index - 1)
    };
    for (const i in this.stepStatusClass) {
      if (this.stepStatusClass[ i ]) {
        this._renderer.addClass(this._el, i);
      } else {
        this._renderer.removeClass(this._el, i);
      }
    }
  }

  updateLastWidth(): void {
    let width = this._stepsHead.nativeElement.offsetWidth + this._stepsMain.nativeElement.offsetWidth;
    /** remove left padding if not first**/
    if (!this._first) {
      width = width - 10;
    }
    this._renderer.setStyle(this.erf.nativeElement, 'width', (100 / (this._totalCount - 1)) + '%');
    this._renderer.setStyle(this.erf.nativeElement, 'margin-right', (-(width / (this._totalCount - 1) + 5)) + 'px');
    if (this._direction === 'horizontal') {
      if (this._stepsTail && this._stepsTail.nativeElement) {
        this._renderer.setStyle(this._stepsTail.nativeElement, 'padding-right', ((width / (this._totalCount - 1) + 5)) + 'px');
      }
    }
  }

  constructor(private erf: ElementRef, private _renderer: Renderer2, public cdr: ChangeDetectorRef) {
    this._el = erf.nativeElement;
  }

  ngAfterViewInit(): void {
    if (!this._last) {
      this.updateLastWidth();
    }
  }
}
